import { render, staticRenderFns } from "./AddressWindow.vue?vue&type=template&id=5b4f43a5&scoped=true&lang=pug&"
import script from "./AddressWindow.vue?vue&type=script&lang=ts&"
export * from "./AddressWindow.vue?vue&type=script&lang=ts&"
import style0 from "./AddressWindow.vue?vue&type=style&index=0&id=5b4f43a5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4f43a5",
  null
  
)

export default component.exports